export default __webpack_public_path__ + "static/media/iotchain.2da9f6bd.png";